import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import Axios, { authHeaders } from "../../utils/axios";

export const addNpaProperties = createAsyncThunk("property/addNpaProperties",async ({data}, { rejectWithValue }) => {
  try {
    const auth = authHeaders();
    const response = await Axios.post(`${process.env.REACT_APP_BASE_URL}/npa-properties`,data,{
          headers: {
            ...auth.headers,                 // ✅ KEEP TOKEN
          
          },
        });
    return response.data; // Success case
  } catch (error) {
    return rejectWithValue(error.response.data); // Error case
  }
});

export const updateNpaProperties = createAsyncThunk("property/updateNpaProperties",async ({ id, data}, { rejectWithValue }) => {
  try {
    const auth = authHeaders();
    const response = await Axios.patch(`${process.env.REACT_APP_BASE_URL}/npa-properties/${id}`,data,{
          headers: {
            ...auth.headers,                 // ✅ KEEP TOKEN
          
          },
        });
    return response.data; // Success case
  } catch (error) {
    return rejectWithValue(error.response.data); // Error case
  }
});

export const deleteProperty = createAsyncThunk("properties/deleteProperty",async({id},{ rejectWithValue }) => {
    try{
     const response = await Axios.delete(`${process.env.REACT_APP_BASE_URL}/npa-properties/${id}`,authHeaders());
     return response.data; //success Case
    }catch(err){
      return rejectWithValue(err.message); // Error case
    }
})

export const npaProperties = createAsyncThunk("properties/npaProperties",async ({status, page, limit, search, asset_category, property_type, possession_type, city_town, reserve_price},{ rejectWithValue }) => {
    try {
      const response = await Axios.get(`${process.env.REACT_APP_BASE_URL}/npa-properties?status=${status || ""}&limit=${limit || 10}&page=${page || 1}&search=${search || ""}&asset_category=${asset_category || ""}&property_type=${property_type || ""}&possession_type=${possession_type || ""}&city_town=${city_town || ""}&reserve_price=${reserve_price || ""}`, authHeaders());
      return response.data; //success Case
    } catch (error) {
      return rejectWithValue(error.message); // Error case
    }
  });

export const npaStatsProperties = createAsyncThunk("properties/npaStatsProperties",async (_,{ rejectWithValue }) => {
    try {
      const response = await Axios.get(`${process.env.REACT_APP_BASE_URL}/npa-properties/stats`, authHeaders());
      return response.data; //success Case
    } catch (error) {
      return rejectWithValue(error.message); // Error case
    }
});

export const propertyDetails = createAsyncThunk("properties/propertyDetails",async ({id},{ rejectWithValue }) => {
    try{
     const response = await Axios.get(`${process.env.REACT_APP_BASE_URL}/npa-properties/${id}`,authHeaders());     
     return response.data; // Success case
    }catch(error){
      return rejectWithValue(error.response.data); // Error case
    }
  });


export const reqToGetFilterData = createAsyncThunk("properties/reqToGetFilterData",async (_,{ rejectWithValue }) => {
  try {
    const response = await Axios.get(`/filters/metadata`,authHeaders());
    return response?.data; // Success case
  } catch (error) {
    return rejectWithValue(error.response.data); // Error case
  }
});

export const importUserList = createAsyncThunk("properties/importUserList",async (data,{ rejectWithValue }) => {
  try {
    const response = await Axios.get(`${process.env.REACT_APP_BASE_URL}/bank`,data, authHeaders());
    return response?.data; // Success case
  } catch (error) {
    return rejectWithValue(error.response.data); // Error case
  }
});

export const importBankUserList = createAsyncThunk(
  "properties/importBankUserList",
  async ({ page = 1, limit = 10, search = "" }, { rejectWithValue }) => {
    try {
      const response = await Axios.get(
        "/bank-users",
        {
          ...authHeaders(),
          params: {
            page,
            limit,
            search,
          },
        }
      );
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response?.data || error.message);
    }
  }
);

export const exportNpaList = createAsyncThunk(
  "user/exportNpaList",
  async (payload, { rejectWithValue }) => {
    const { status } = payload;

    try {
      const response = await Axios.get(
        `${process.env.REACT_APP_BASE_URL}/npa-properties/export`,
        {
          responseType: "blob",
          params: { status },
          ...authHeaders(),
        }
      );
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response?.data || error.message);
    }
  }
);


export const reqToImportNpaProperties = createAsyncThunk("properties/reqToImportNpaProperties",async ({data},{ rejectWithValue }) => {
  try {
    const auth = authHeaders();
    const response = await Axios.post(`${process.env.REACT_APP_BASE_URL}/npa-properties/import`,data,{
          headers: {
            ...auth.headers,                
          
          },
        });
        console.log("RESPOSNESSS", response);
        
    return response?.data; // Success case
  } catch (error) {
  return rejectWithValue(
    error.response?.data || {
      message: "Invalid file format",
    }
  );
}

});

export const propertyTypesDropdown = createAsyncThunk("properties/propertyTypesDropdown",async (_,{ rejectWithValue }) => {
  try {
    const response = await Axios.get(`${process.env.REACT_APP_BASE_URL}/npa-properties/meta`,authHeaders());    
    return response?.data; // Success case
  } catch (error) {
    return rejectWithValue(error.response.data); // Error case
  }
});


const propertiesSlice = createSlice({
  name: "properties",
  initialState: {
    user: null,
    isAuthenticated: false,
    isLoading: false,
    error: null,
    property: [],
    metaNpaProperty: {},
    propertyDetail:{},
    filter:{},
    npaStats:{},
    bankUserList: [],
    addProperty:{},
    updateProperty:{},
    deleteNpaProperty:{},
    importData:[],
    importBankUsers:[],
    propertyDropdown:[],
    bankUsersList:[]
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
       // Add NPA Property
       .addCase(addNpaProperties.pending, (state, action) => {
        state.isLoading = true;
      })
       .addCase(addNpaProperties.fulfilled, (state, action) => {
        state.isLoading = false;
        state.addProperty = action.payload;
      })
      .addCase(addNpaProperties.rejected, (state, action) => {
        state.isLoading = false;
      })
      // Update NPA Property
      .addCase(updateNpaProperties.pending, (state, action) => {
        state.isLoading = true;
      })
        .addCase(updateNpaProperties.fulfilled, (state, action) => {
        state.isLoading = false;
        state.updateProperty = action.payload;
      })
      .addCase(updateNpaProperties.rejected, (state, action) => {
        state.isLoading = false;
      })
       // NPA Property List
       .addCase(npaProperties.pending, (state, action) => {
        state.isLoading = true;
      })
      .addCase(npaProperties.fulfilled, (state, action) => {
        state.isLoading = false;
        state.property = action.payload;
      })
      .addCase(npaProperties.rejected, (state, action) => {
        state.isLoading = false;
      })
      // NPA Property Details
      .addCase(propertyDetails.fulfilled, (state, action) => {
        state.isLoading = false;
        state.propertyDetail = action.payload.data;
      })
      // Delete NPA Property
      .addCase(deleteProperty.pending, (state, action) => {
        state.isLoading = true;
      })
      .addCase(deleteProperty.fulfilled, (state, action) => {
        state.isLoading = false;
        state.deleteNpaProperty = action.payload;
      })
      .addCase(deleteProperty.rejected, (state, action) => {
        state.isLoading = false;
      })
      // request to fetch filter data
      .addCase(reqToGetFilterData.fulfilled, (state, action) => {
        state.isLoading = false;
        state.filter = action.payload;
      })
      // request to get list of Import Users
      .addCase(importUserList.fulfilled, (state, action) => {
        state.isLoading = false;
        state.bankUserList = action.payload;
      })
      .addCase(importBankUserList.fulfilled, (state, action) => {        
        state.isLoading = false;
        state.bankUsersList = action.payload.data || []; // ✅ ONLY ARRAY
      })
      // request to import Npa Properties
      .addCase(reqToImportNpaProperties.fulfilled, (state, action) => {
        state.isLoading = false;
        state.importData = action.payload;
      })
      // request to Types of property Dropdown
      .addCase(propertyTypesDropdown.fulfilled, (state, action) => {
        state.isLoading = false;
        state.propertyDropdown = action.payload.data;
      })
      .addCase(npaStatsProperties.fulfilled, (state, action) => {
        state.isLoading = false;
        state.npaStats = action.payload.data;
      })
  },
});

export default propertiesSlice.reducer;
